import indexStartWith from "../../../../utils/index-start-with";

/**
 * Get trigger type
 * @param {String} input Trigger name
 */
const getTriggerType = (input) => {
  switch (true) {
    case indexStartWith(input, ["hover"]):
      return "hover";

    case indexStartWith(input, ["click"]):
      return "click";

    case indexStartWith(input, ["."]):
      return "class";

    case indexStartWith(input, ["@"]):
      return "reference";

    case indexStartWith(input, ["animate"]):
      return "animate";

    case indexStartWith(input, ["mouse", "pointer"]):
      return "pointer";

    case indexStartWith(input, ["scroll"]):
      return "scroll";

    case indexStartWith(input, ["focus-within"]):
      return "focus-within";

    case indexStartWith(input, ["focus"]):
      return "focus";

    case indexStartWith(input, ["inview", "outview"]):
      return "viewport";

    case indexStartWith(input, ["timeout"]):
      return "timeout";

    case indexStartWith(input, ["active"]):
      return "active";

    case indexStartWith(input, ["check", "uncheck", "select", "change"]):
      return "change";

    case indexStartWith(input, ["shift"]):
      return "shift";

    default:
      return "initial";
  }
};

export default getTriggerType;
